import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography, TextField, Grid, MenuItem, Select, FormControl, InputLabel, Divider } from "@mui/material";
import { Add, CheckCircle, Download } from '@mui/icons-material';
import apiService from "../../service/apiService";
import { FaListAlt, FaArrowRight, FaMap, FaCrop, FaUsers, FaEye, FaRegEdit, FaTrash, FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import ReactApexChart from "react-apexcharts";
import '../../assets/styles/cropmanage.css';
import * as XLSX from "xlsx";
import UploadIcon from '@mui/icons-material/Upload';
import { Pagination } from "react-bootstrap";
import { format, parseISO } from "date-fns";
import { debounce } from "lodash";

const Cropplan = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Essential state variables only
  const [openEdit, setOpenEdit] = useState(false);
  const [pageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [newState, setNewState] = useState({ seasonId: null, yearId: null, farmerId: null });
  const [seasons, setSeasons] = useState([]);
  const [years, setYears] = useState([]);
  const [farmers, setFarmers] = useState([]);
  const [farmerName, setFarmerName] = useState('');
  const [seeds, setSeeds] = useState([]);
  const [totalItems, setTotalitems] = useState(0);
  const [totalpage, setTotalpage] = useState(0);
  const [farName, setFarName] = useState("");
  const [gendid, setGendId] = useState(0);
  const [genders, setGenders] = useState([]);
  const [castid, setCastId] = useState(0);
  const [sesid, setSesId] = useState(location.state?.season || 0);
  const [pgcode, setPgCode] = useState("");
  const [totalplannedarea, setTotalPlannedArea] = useState(null);
  const [castes, setCastes] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [cropPlans, setCropPlans] = useState([]);
  const [seedVarietyId, setSeedVarietyId] = useState('');
  const [seedVarieties, setSeedVarieties] = useState([]);
  const [seedClassId, setSeedClassId] = useState('');
  const [seedClasses, setSeedClasses] = useState([]);
  const [cropTypes, setCropTypes] = useState([]);
  const [cropPlanMasterId, setCropPlanMasterId] = useState("");
  const [seedId, setSeedId] = useState("");
  const [cropTypeId, setCropTypeId] = useState("");
  const [area, setArea] = useState("");
  const [leasearea, setLeaseArea] = useState("");
  const [quantity, setQuantity] = useState("");
  const [openAddPlan, setOpenAddPlan] = useState(false);
  const [selectedSeasonId, setSelectedSeasonId] = useState(0);
  const [carddata, setCardData] = useState([]);
  const [alldata, setAllData] = useState([]);
  const [year, setYear] = useState(location.state?.year || null);
  const [showBreakupfarmer, setShowBreakupfarmer] = useState(false);
  const [showBreakupplan, setShowBreakupplan] = useState(false);
  const [crops, setCrops] = useState([]);
  const [farmersData, setFarmersData] = useState([]);
  const [farmerArea, setfarmerArea] = useState([]);
  const [planmstrid, setPlanmstrId] = useState(null);
  const [isLeaseArea, setIsLeaseArea] = useState(false);
  const [selectedFarmerid, setSelectedFarmerId] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [districts, setDistricts] = useState([]);
  const [availablearea, setAvailableArea] = useState(0);
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);

  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const [dist, setDist] = useState(
    loginData?.districtId !== null && loginData?.districtId !== undefined
      ? loginData.districtId
      : (location.state?.dist && location.state.dist !== 0 ? location.state.dist : 0)
  );
  const [blk, setBlk] = useState(
    loginData?.blockId !== null && loginData?.blockId !== undefined
      ? loginData.blockId
      : (location.state?.blk && location.state.blk !== 0 ? location.state.blk : 0)
  );

  // Essential useEffects
  useEffect(() => {
    if (!seedId || !cropTypeId || !seedClassId || !seedVarietyId) {
      setIsSaveDisabled(true);
    } else {
      setIsSaveDisabled(false);
    }
  }, [seedId, cropTypeId, seedClassId, seedVarietyId]);

  const handleSelectRow = (id, isVerified) => {
    if (isVerified) return;
    setSelectedRows((prev) => {
      const newSelectedRows = prev.includes(id)
        ? prev.filter((rowId) => rowId !== id)
        : [...prev, id];
      setSelectAll(newSelectedRows.length === alldata.filter((data) => !data.isVerified).length);
      return newSelectedRows;
    });
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]);
    } else {
      const selectableIds = alldata.filter((data) => !data.isVerified).map((data) => data.id);
      setSelectedRows(selectableIds);
    }
    setSelectAll(!selectAll);
  };

  useEffect(() => {
    const loadDistricts = async () => {
      try {
        const res = await apiService.get("/districts/get-all");
        if (res.data) {
          setDistricts(res.data);
        }
      } catch (err) {
        console.error("Error fetching districts:", err);
      }
    };
    loadDistricts();
  }, []);

  const fetchFarmerDetailsById = async () => {
    try {
      const response = await apiService.get(`/farmers/get-farmer-details/${parseInt(selectedFarmerid)}`);
      setAvailableArea(response.data.body.availableLand);
    } catch (error) {
      console.error("Error fetching farmers:", error);
    }
  };

  useEffect(() => {
    if (parseInt(selectedFarmerid) > 0) {
      fetchFarmerDetailsById();
    }
  }, [parseInt(selectedFarmerid)]);

  const toggleBreakupFarmer = () => {
    setShowBreakupfarmer(!showBreakupfarmer);
  };

  const fetchData = async () => {
    try {
      const response = await apiService.post("/crop-plan-master/get-all-cropplan-index-data", {
        farmerId: 0,
        producerGroupId: 0,
        seasonId: selectedSeasonId,
        farmerName: farName,
        genderId: gendid,
        casteId: castid,
        pgCode: pgcode,
        totalPlannedArea: totalplannedarea,
        year: year,
        pageNumber: page,
        pageSize: pageSize,
        districtId: dist,
        blockId: blk
      });

      if (response.data.status && response.data.body && response.data.body.data) {
        const data = response.data.body.data;
        const formattedData = data.map((item) => ({
          id: item.cropPlanMasterId,
          farmerId: item.farmerId,
          farmer: item.farmerName,
          gender: item.gender,
          caste: item.caste,
          season: item.seasonName,
          pgCode: item.pgCode,
          totalPlannedArea: item.totalArea || 0,
          isVerified: item.isVerified
        }));

        setAllData(formattedData);
        setTotalitems(response.data.body.recordsCount);
        setTotalpage(response.data.body.pageCount);
        setRows(formattedData);
      } else {
        setTotalitems(0);
        setTotalpage(0);
        setAllData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setAllData([]);
      setTotalitems(0);
      setTotalpage(0);
    }
  };

  const debouncedFetchData = useCallback(debounce(fetchData, 500), [
    farName, gendid, castid, sesid, selectedSeasonId, pgcode, totalplannedarea, 
    page, pageSize, year, blk, dist
  ]);

  useEffect(() => {
    debouncedFetchData();
    return () => debouncedFetchData.cancel();
  }, [debouncedFetchData]);

  const fetchCardData = async () => {
    try {
      const response = await apiService.post(`/dashboard/cropplan`, {
        seasonId: selectedSeasonId,
        year: year,
        districtId: dist,
        blockId: blk
      });
      setCardData(response.data.body);
    } catch (error) {
      console.error("Error fetching card data:", error);
    }
  };

  const fetchgraphData = async () => {
    try {
      const response = await apiService.post(`/dashboard/cropplan-graph`, {
        seasonId: selectedSeasonId,
        year: year,
        districtId: dist,
        blockId: blk
      });

      const body = response.data?.body;
      if (!response.data?.status || !response.data?.body) {
        setCrops([]);
        setFarmersData([]);
        setfarmerArea([]);
        return;
      }

      const crops = Object.keys(body).filter(key => key !== 'Season');
      setCrops(crops);
      const farmersData = crops.map(crop => body[crop]?.farmersCount || 0);
      setFarmersData(farmersData);
      const areaData = crops.map(crop => body[crop]?.totalPlannedArea || 0);
      setfarmerArea(areaData);
    } catch (error) {
      console.error("Error fetching graph data:", error);
    }
  };

  const fetchSeasons = async () => {
    try {
      const response = await apiService.get("/seasons/get-all");
      setSeasons(response.data);
    } catch (error) {
      console.error("Error fetching seasons:", error);
    }
  };

  const fetchYears = async () => {
    try {
      const response = await apiService.get("/years/get-all");
      setYears(response.data);
      const currentYear = new Date().getFullYear();
      const defaultYear = response.data.find((yr) => yr.yearValue === currentYear);
      setYear(defaultYear ? defaultYear.yearValue : response.data[0].yearValue);
    } catch (error) {
      console.error("Error fetching years:", error);
    }
  };

  const fetchFarmers = async () => {
    try {
      const response = await apiService.get("/farmers/get-all");
      setFarmers(response.data.filter((farmer) => farmer.isActive));
    } catch (error) {
      console.error("Error fetching farmers:", error);
    }
  };

  const fetchCaste = async () => {
    try {
      const response = await apiService.get("/castes/get-all");
      setCastes(response.data);
    } catch (error) {
      console.error("Error fetching castes:", error);
    }
  };

  const fetchSeeds = async () => {
    try {
      const response = await apiService.get('/seeds/get-all');
      setSeeds(response.data);
    } catch (error) {
      console.error('Error fetching seeds:', error);
    }
  };

  const fetchCropTypes = async () => {
    try {
      const response = await apiService.get('/croptypes/get-all-croptypes');
      setCropTypes(response.data);
    } catch (error) {
      console.error('Error fetching crop types:', error);
    }
  };

  const fetchSeedClasses = async () => {
    try {
      const response = await apiService.get('/seed-classes/get-all');
      setSeedClasses(response.data);
    } catch (error) {
      console.error('Error fetching seed classes:', error);
    }
  };

  const fetchSeedVarieties = async () => {
    try {
      const response = await apiService.get('/seed-varieties/get-all');
      setSeedVarieties(response.data);
    } catch (error) {
      console.error('Error fetching seed varieties:', error);
    }
  };

  useEffect(() => {
    fetchSeasons();
    fetchYears();
    fetchFarmers();
    fetchSeedVarieties();
    fetchSeedClasses();
    fetchCropTypes();
    fetchSeeds();
    fetchCaste();
  }, []);

  useEffect(() => {
    if (selectedSeasonId !== null && year !== null) {
      fetchCardData();
      fetchgraphData();
    }
  }, [selectedSeasonId, year, dist, blk]);

  // Chart configuration
  const getColumnWidth = () => {
    const numCrops = crops.length;
    if (numCrops <= 1) return "5%";
    else if (numCrops <= 4) return "10%";
    else return "30%";
  };

  const chartOptions = {
    chart: { type: "bar", toolbar: { show: true } },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: getColumnWidth(),
        borderRadius: 5,
        borderRadiusApplication: "end",
      },
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: crops,
      title: { text: "Crops", style: { fontSize: "14px", fontWeight: "bold" } },
    },
    yaxis: {
      title: { text: "Counts", style: { fontSize: "14px", fontWeight: "bold" } },
    },
    colors: ["#00773E", "#ee781c"],
    legend: { position: "bottom", horizontalAlign: "center" },
    grid: { borderColor: "#e7e7e7", strokeDashArray: 5 },
  };

  const chartSeries = [
    { name: "Farmer (no.)", data: farmersData },
    { name: "Total Area (ha)", data: farmerArea },
  ];

  // Event handlers
  const handleEdit = async (cropPlanMasterId) => {
    try {
      setPlanmstrId(cropPlanMasterId);
      const response = await apiService.get(`/crop-plan-master/getIds/${cropPlanMasterId}`);
      if (response.status === 200) {
        const { YearId, FarmerId, SeasonId } = response.data;
        setNewState({
          yearId: YearId || null,
          farmerId: FarmerId || null,
          seasonId: SeasonId || null,
        });
        setOpenEdit(true);
      }
    } catch (error) {
      console.error("Error fetching crop plan data:", error);
    }
  };

  const handleView = async (data) => {
    const cropPlanMasterId = data.id;
    try {
      const response = await apiService.get(`/crop-plan-master/get-cropplan-details/${cropPlanMasterId}`);
      if (response.data.status) {
        const cropPlans = response.data.body.cropPlans;
        navigate("/plans", {
          state: { cropPlans: cropPlans, selectedRow: data },
        });
      }
    } catch (error) {
      console.error("Error fetching crop plan details:", error);
    }
  };

  const handleDelete = (id) => {
    setSelectedRow(rows.find((row) => row.id === id));
    setOpenDelete(true);
  };

  const handleDeleteRow = async () => {
    try {
      const { id } = selectedRow;
      await apiService.delete(`/crop-plan-master/delete/${id}`);
      fetchData();
    } catch (error) {
      console.error("Error deleting data:", error);
    } finally {
      setOpenDelete(false);
    }
  };

  const handleVerify = async () => {
    const isConfirmed = window.confirm("Are you sure you want to verify the selected crop plans?");
    if (!isConfirmed) return;

    try {
      const response = await apiService.put('/crop-plan-master/verify', {
        cropPlanMasterIds: selectedRows,
        remarks: "Verified successfully"
      });

      if (response.status === 200) {
        alert("Verification successful!");
        setSelectedRows([]);
        fetchData();
      }
    } catch (error) {
      alert("Error verifying records: " + error.message);
    }
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const renderPaginationItems = () => {
    const paginationItems = [];
    const maxPagesToShow = 7;
    const startPages = 3;
    const endPages = 2;

    if (totalpage <= maxPagesToShow) {
      for (let pages = 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    } else {
      for (let pages = 1; pages <= startPages; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      if (page > startPages + 1) {
        paginationItems.push(<Pagination.Ellipsis key="start-ellipsis" />);
      }

      const middlePages = [];
      const startMiddlePage = Math.max(page - 1, startPages + 1);
      const endMiddlePage = Math.min(page + 1, totalpage - endPages);

      for (let pages = startMiddlePage; pages <= endMiddlePage; pages++) {
        middlePages.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      paginationItems.push(...middlePages);

      if (page < totalpage - endPages - 1) {
        paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" />);
      }

      for (let pages = totalpage - endPages + 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    }

    return paginationItems;
  };

  const exportToExcel = async () => {
    const headers = [
      ["Farmer Name", "Gender", "Caste", "Season", "PG Code", "Total Area (ha)", "Seed Name", "Class Name", "Variety Name", "Crop Type", "Crop Plan Date", "Area", "Lease Area", "Status"]
    ];

    const payload = {
      "farmerId": 0, "producerGroupId": 0, "seasonId": 0, "farmerName": "",
      "genderId": 0, "casteId": 0, "pgCode": "", "totalPlannedArea": null,
      "year": year, "pageNumber": page, "pageSize": 1000000000
    };

    try {
      const response = await apiService.post("/crop-plan-master/get-all-cropplan-index-data", payload);

      if (response && response.data && response.data.body && response.data.body.data) {
        const cropPlanData = response.data.body.data;
        const dataRows = cropPlanData.flatMap(data => {
          return data.cropPlanDetails.map((detail, index) => [
            index === 0 ? data.farmerName : "",
            index === 0 ? data.gender : "",
            index === 0 ? data.caste : "",
            index === 0 ? data.seasonName : "",
            index === 0 ? data.pgCode : "",
            index === 0 ? data.totalArea : "",
            detail.seedName, detail.className, detail.varietyName, detail.cropType,
            detail.cropPlanDate ? format(parseISO(detail.cropPlanDate), "dd-MM-yyyy") : "N/A",
            detail.area, detail.leaseArea, detail.status
          ]);
        });

        const worksheetData = [...headers, ...dataRows];
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Crop Plans");
        XLSX.writeFile(workbook, `Crop_Planned_Data_${year}.xlsx`);
      }
    } catch (error) {
      console.error("Error fetching data or exporting to Excel:", error);
    }
  };

  return (
    <Box m="2px">
      <div style={{ maxHeight: "100vh", overflowY: "auto" }}>
        {/* Header - Same design as other components */}
        <div style={{
          backgroundColor: "#ffffff",
          borderBottom: "3px solid #007bff",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
        }}>
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center py-3 px-4">
              <div className="d-flex align-items-center">
                <div>
                  <h1 style={{
                    fontSize: "1.8rem",
                    fontWeight: "600",
                    color: "#2c3e50",
                    margin: "0"
                  }}>
                    Crop Plan Dashboard
                  </h1>
                </div>
              </div>

              <div className="d-flex align-items-center gap-3">
                <div className="d-flex align-items-center">
                  <label style={{
                    fontWeight: "500",
                    color: "#495057",
                    marginRight: "10px",
                    fontSize: "14px"
                  }}>
                    Year:
                  </label>
                  <select
                    className="form-select"
                    value={year || 0}
                    onChange={(e) => setYear(Number(e.target.value))}
                    style={{
                      border: "1px solid #ced4da",
                      borderRadius: "6px",
                      padding: "6px 12px",
                      fontSize: "14px",
                      minWidth: "100px",
                      backgroundColor: "#fff"
                    }}
                  >
                    <option value={0} disabled>Select Year</option>
                    {years.map((yr) => (
                      <option key={yr.yearId} value={yr.yearValue}>
                        {yr.yearValue}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="d-flex align-items-center">
                  <label style={{
                    fontWeight: "500",
                    color: "#495057",
                    marginRight: "10px",
                    fontSize: "14px"
                  }}>
                    District:
                  </label>
                  <select
                    className="form-select"
                    value={dist || 0}
                    onChange={(e) => { setDist(Number(e.target.value)); setPage(1); }}
                    style={{
                      border: "1px solid #ced4da",
                      borderRadius: "6px",
                      padding: "6px 12px",
                      fontSize: "14px",
                      minWidth: "150px",
                      backgroundColor: "#fff"
                    }}
                  >
                    <option value={0}>Select All</option>
                    {districts.map((d) => (
                      <option key={d.districtId} value={d.districtId}>
                        {d.districtName}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="d-flex align-items-center">
                  <label style={{
                    fontWeight: "500",
                    color: "#495057",
                    marginRight: "10px",
                    fontSize: "14px"
                  }}>
                    Season:
                  </label>
                  <select
                    className="form-select"
                    value={selectedSeasonId}
                    onChange={(e) => { setSelectedSeasonId(Number(e.target.value)); setPage(1); }}
                    style={{
                      border: "1px solid #ced4da",
                      borderRadius: "6px",
                      padding: "6px 12px",
                      fontSize: "14px",
                      minWidth: "120px",
                      backgroundColor: "#fff"
                    }}
                  >
                    <option value={0}>Select All</option>
                    {seasons.map((ses) => (
                      <option key={ses.seasonId} value={ses.seasonId}>
                        {ses.seasonName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Dashboard Cards - Updated to match index.jsx design */}
        <div className="row g-3 mx-3 mt-1">
          <div className="col-3">
            <div
              className="d-flex align-items-center justify-content-between p-4 position-relative"
              style={{
                minHeight: "120px",
                backgroundColor: "#d4edc9",
                borderRadius: "8px",
                cursor: "pointer",
                transition: "0.2s ease-in-out",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#c7e6b8")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#d4edc9")}
              onClick={toggleBreakupFarmer}
            >
              <FaUsers size={60} style={{ color: "#2e7d32" }} />
              <div className="text-end flex-grow-1">
                <h5 className="fw-bold mb-0" style={{ color: "#2e7d32" }}>
                  {carddata?.totalFarmerCount || 0}
                </h5>
                <small className="fw-bold" style={{ color: "#33691e", fontSize: "15px" }}>
                  Participant Farmers (no.)
                </small>
                <div className="mt-2 fw-bold" style={{ fontSize: "12px", color: "#2e7d32" }}>
                  {showBreakupfarmer ? "Close Breakup" : "View Breakup"} <FaArrowRight />
                </div>
              </div>
              {showBreakupfarmer && (
                <div className="position-absolute p-3 text-dark rounded shadow"
                  style={{
                    backgroundColor: "white", top: "50%", left: "50%",
                    transform: "translate(-50%, -50%)", width: "90%", zIndex: 10,
                    borderRadius: "12px"
                  }}>
                  <div className="text-start">
                    <p className="mb-1 fw-bold">Men: <span className="text-primary">{carddata?.maleCount || 0}</span></p>
                    <p className="mb-0 fw-bold">Women: <span className="text-danger">{carddata?.femaleCount || 0}</span></p>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="col-3">
            <div
              className="d-flex align-items-center justify-content-between p-4"
              style={{
                minHeight: "120px",
                backgroundColor: "#d4edc9",
                borderRadius: "8px",
                cursor: "pointer",
                transition: "0.2s ease-in-out",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#c7e6b8")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#d4edc9")}
            >
              <FaListAlt size={60} style={{ color: "#2e7d32" }} />
              <div className="text-end flex-grow-1">
                <h5 className="fw-bold mb-0" style={{ color: "#2e7d32" }}>
                  {carddata?.totalPgCount || 0}
                </h5>
                <small className="fw-bold" style={{ color: "#33691e", fontSize: "15px" }}>
                  Participant PGs (no.)
                </small>
              </div>
            </div>
          </div>

          <div className="col-3">
            <div
              className="d-flex align-items-center justify-content-between p-4"
              style={{
                minHeight: "120px",
                backgroundColor: "#d4edc9",
                borderRadius: "8px",
                cursor: "pointer",
                transition: "0.2s ease-in-out",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#c7e6b8")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#d4edc9")}
            >
              <FaMap size={60} style={{ color: "#2e7d32" }} />
              <div className="text-end flex-grow-1">
                <h5 className="fw-bold mb-0" style={{ color: "#2e7d32" }}>
                  {carddata?.totalPlannedArea || 0}
                </h5>
                <small className="fw-bold" style={{ color: "#33691e", fontSize: "15px" }}>
                  Area Plan (ha)
                </small>
              </div>
            </div>
          </div>

          <div className="col-3">
            <div
              className="d-flex align-items-center justify-content-between p-4"
              style={{
                minHeight: "120px",
                backgroundColor: "#d4edc9",
                borderRadius: "8px",
                cursor: "pointer",
                transition: "0.2s ease-in-out",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#c7e6b8")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#d4edc9")}
            >
              <FaCrop size={60} style={{ color: "#2e7d32" }} />
              <div className="text-end flex-grow-1">
                <h5 className="fw-bold mb-0" style={{ color: "#2e7d32" }}>
                  {carddata?.totalCropPlans || 0}
                </h5>
                <small className="fw-bold" style={{ color: "#33691e", fontSize: "15px" }}>
                  Total Crop Plan (ha)
                </small>
              </div>
            </div>
          </div>
        </div>

        {/* Chart Section */}
        {/* <div className="d-flex justify-content-between align-items-center mt-4 mx-3">
          <div className="fw-bold fs-5">Season Analysis Summary</div>
        </div> */}
        {/* <div className="mt-4 mb-2 mx-3">
          <ReactApexChart options={chartOptions} series={chartSeries} type="bar" height={350} />
        </div> */}

        {/* Action Buttons */}
        <div className="d-flex justify-content-between align-items-center mt-3 mx-3">
          <div className="fw-bold fs-5">Farmer-wise Crop Plan Details</div>
          <div className="d-flex align-items-center gap-3">
            <Button
              variant="contained"
              onClick={() => navigate("/addplan")}
              style={{
                backgroundColor: "#28a745",
                border: "none",
                borderRadius: "6px",
                padding: "8px 16px",
                fontSize: "14px",
                fontWeight: "500",
                textTransform: "none"
              }}
            >
              + Add New
            </Button>
            
            <Button
              variant="contained"
              component="label"
              style={{
                backgroundColor: "#17a2b8",
                border: "none",
                borderRadius: "6px",
                padding: "8px 16px",
                fontSize: "14px",
                fontWeight: "500",
                textTransform: "none"
              }}
            >
              Upload Excel
              <input
                type="file"
                accept=".xlsx, .xls"
                hidden
                onChange={(event) => {
                  const file = event.target.files[0];
                  if (file) {
                    const confirmUpload = window.confirm("Are you sure you want to upload this file?");
                    if (confirmUpload) {
                      const formData = new FormData();
                      formData.append("file", file);
                      apiService.post("/upload/cropplan-upload", formData, {
                        headers: { accept: "*/*", "Content-Type": "multipart/form-data" },
                      })
                        .then(() => { alert("File uploaded successfully!"); fetchData(); })
                        .catch(() => { alert("Failed to upload file. Please try again."); });
                    }
                  }
                }}
              />
            </Button>
            
            <Button
              variant="contained"
              onClick={exportToExcel}
              style={{
                backgroundColor: "#007bff",
                border: "none",
                borderRadius: "6px",
                padding: "8px 16px",
                fontSize: "14px",
                fontWeight: "500",
                textTransform: "none"
              }}
            >
              Export Excel
            </Button>
            
            {/* <Button
              variant="contained"
              onClick={handleVerify}
              disabled={selectedRows.length === 0}
              style={{
                backgroundColor: "#00796b",
                border: "none",
                borderRadius: "6px",
                padding: "8px 16px",
                fontSize: "14px",
                fontWeight: "500",
                textTransform: "none",
                opacity: selectedRows.length === 0 ? 0.6 : 1
              }}
            >
              Verify
            </Button> */}
          </div>
        </div>

        {/* Table Section - Restored original scrollable structure */}
        <div className="mx-2" style={{ minHeight: "75vh", overflowY: "auto", overflowX: "auto", maxWidth: "100%", whiteSpace: "nowrap" }}>
          <table className="table table-hover mb-0" style={{
            minWidth: "1200px",
            backgroundColor: "#fff"
          }}>
            <thead style={{
              backgroundColor: "#007bff",
              color: "white",
              position: "sticky",
              top: "0",
              zIndex: "10"
            }}>
              <tr>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  textAlign: "center",
                  borderRight: "1px solid rgba(255,255,255,0.2)",
                  minWidth: "60px"
                }}>
                  <input
                    type="checkbox"
                    onChange={handleSelectAll}
                    checked={selectAll && selectedRows.length > 0}
                    style={{ transform: "scale(1.2)" }}
                  />
                </th>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  borderRight: "1px solid rgba(255,255,255,0.2)",
                  minWidth: "150px"
                }}>
                  Farmer Name
                  <br />
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm mt-2"
                    value={farName}
                    onChange={(e) => { setFarName(e.target.value); setPage(1); }}
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      fontSize: "12px",
                      color: "#333",
                      padding: "4px 8px"
                    }}
                  />
                </th>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  borderRight: "1px solid rgba(255,255,255,0.2)",
                  minWidth: "100px"
                }}>
                  Gender
                  <br />
                  <select
                    value={gendid}
                    onChange={(e) => { setGendId(e.target.value); setPage(1); }}
                    className="form-control form-control-sm mt-2"
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      fontSize: "12px",
                      color: "#333",
                      padding: "4px 8px"
                    }}
                  >
                    <option value={0}>All</option>
                    {genders.map((gender) => (
                      <option key={gender.genderId} value={gender.genderId}>
                        {gender.gender}
                      </option>
                    ))}
                  </select>
                </th>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  borderRight: "1px solid rgba(255,255,255,0.2)",
                  minWidth: "100px"
                }}>
                  Caste
                  <br />
                  <select
                    value={castid}
                    onChange={(e) => { setCastId(e.target.value); setPage(1); }}
                    className="form-control form-control-sm mt-2"
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      fontSize: "12px",
                      color: "#333",
                      padding: "4px 8px"
                    }}
                  >
                    <option value={0}>All</option>
                    {castes.map((caste) => (
                      <option key={caste.casteId} value={caste.casteId}>
                        {caste.caste}
                      </option>
                    ))}
                  </select>
                </th>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  borderRight: "1px solid rgba(255,255,255,0.2)",
                  minWidth: "100px"
                }}>
                  Season
                  <br />
                  <select
                    value={selectedSeasonId}
                    onChange={(e) => { setSelectedSeasonId(Number(e.target.value)); setPage(1); }}
                    className="form-control form-control-sm mt-2"
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      fontSize: "12px",
                      color: "#333",
                      padding: "4px 8px"
                    }}
                  >
                    <option value={0}>All</option>
                    {seasons.map((season) => (
                      <option key={season.seasonId} value={season.seasonId}>
                        {season.seasonName}
                      </option>
                    ))}
                  </select>
                </th>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  borderRight: "1px solid rgba(255,255,255,0.2)",
                  minWidth: "120px"
                }}>
                  PG Code
                  <br />
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm mt-2"
                    value={pgcode}
                    onChange={(e) => { setPgCode(e.target.value); setPage(1); }}
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      fontSize: "12px",
                      color: "#333",
                      padding: "4px 8px"
                    }}
                  />
                </th>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  borderRight: "1px solid rgba(255,255,255,0.2)",
                  minWidth: "120px"
                }}>
                  Planned Area (ha)
                  <br />
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm mt-2"
                    value={totalplannedarea}
                    onChange={(e) => { setTotalPlannedArea(e.target.value); setPage(1); }}
                    style={{
                      backgroundColor: "#ffffff",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      fontSize: "12px",
                      color: "#333",
                      padding: "4px 8px"
                    }}
                  />
                </th>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  borderRight: "1px solid rgba(255,255,255,0.2)",
                  minWidth: "100px",
                  textAlign: "center"
                }}>
                  Status
                </th>
                <th style={{
                  padding: "15px 12px",
                  fontWeight: "600",
                  fontSize: "13px",
                  textAlign: "center",
                  minWidth: "150px"
                }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody style={{ fontSize: "13px" }}>
              {alldata.map((data, index) => (
                <tr key={index} style={{
                  backgroundColor: index % 2 === 0 ? "#f8f9fa" : "#ffffff",
                  borderBottom: "1px solid #dee2e6"
                }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#e3f2fd";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = index % 2 === 0 ? "#f8f9fa" : "#ffffff";
                  }}>
                  <td style={{
                    padding: "12px 8px",
                    textAlign: "center",
                    borderRight: "1px solid #dee2e6"
                  }}>
                    <input
                      type="checkbox"
                      checked={selectedRows.includes(data.id)}
                      onChange={() => handleSelectRow(data.id, data.isVerified)}
                      disabled={data.isVerified}
                      style={{ transform: "scale(1.2)" }}
                    />
                  </td>
                  <td style={{
                    padding: "12px 8px",
                    color: "#495057",
                    borderRight: "1px solid #dee2e6",
                    fontWeight: "500"
                  }}>
                    {data.farmer}
                  </td>
                  <td style={{
                    padding: "12px 8px",
                    color: "#495057",
                    borderRight: "1px solid #dee2e6"
                  }}>
                    <span style={{
                      backgroundColor: data.gender === 'Male' ? '#d4edda' : data.gender === 'Female' ? '#f8d7da' : '#fff3cd',
                      color: data.gender === 'Male' ? '#155724' : data.gender === 'Female' ? '#721c24' : '#856404',
                      padding: "3px 8px",
                      borderRadius: "4px",
                      fontSize: "11px",
                      fontWeight: "500"
                    }}>
                      {data.gender}
                    </span>
                  </td>
                  <td style={{
                    padding: "12px 8px",
                    color: "#495057",
                    borderRight: "1px solid #dee2e6"
                  }}>
                    {data.caste}
                  </td>
                  <td style={{
                    padding: "12px 8px",
                    color: "#495057",
                    borderRight: "1px solid #dee2e6"
                  }}>
                    <span style={{
                      backgroundColor: data.season === 'Rabi' ? '#d4edda' : '#fff3cd',
                      color: data.season === 'Rabi' ? '#155724' : '#856404',
                      padding: "3px 8px",
                      borderRadius: "4px",
                      fontSize: "11px",
                      fontWeight: "500"
                    }}>
                      {data.season}
                    </span>
                  </td>
                  <td style={{
                    padding: "12px 8px",
                    color: "#495057",
                    borderRight: "1px solid #dee2e6"
                  }}>
                    {data.pgCode}
                  </td>
                  <td style={{
                    padding: "12px 8px",
                    textAlign: "center",
                    fontWeight: "600",
                    color: "#495057",
                    borderRight: "1px solid #dee2e6"
                  }}>
                    <span style={{
                      backgroundColor: '#007bff',
                      color: 'white',
                      padding: "3px 8px",
                      borderRadius: "4px",
                      fontSize: "12px",
                      fontWeight: "600"
                    }}>
                      {data.totalPlannedArea}
                    </span>
                  </td>
                  <td style={{
                    padding: "12px 8px",
                    textAlign: "center",
                    fontWeight: "600",
                    borderRight: "1px solid #dee2e6"
                  }}>
                    <span style={{
                      color: data.isVerified ? "#28a745" : "#dc3545",
                      fontWeight: "600",
                      fontSize: "12px"
                    }}>
                      {data.isVerified ? "Verified" : "Not Verified"}
                    </span>
                  </td>
                  <td style={{
                    padding: "12px 8px",
                    textAlign: "center"
                  }}>
                    <div style={{ display: "flex", gap: "5px", justifyContent: "center" }}>
                      <button
                        className="btn btn-sm btn-info"
                        onClick={() => handleView(data)}
                        title="View"
                        style={{
                          padding: "4px 8px",
                          fontSize: "12px"
                        }}
                      >
                        <FaEye />
                      </button>
                      {/* <button
                        className="btn btn-sm btn-success"
                        onClick={() => handleEdit(data.id)}
                        title="Edit"
                        style={{
                          padding: "4px 8px",
                          fontSize: "12px"
                        }}
                      >
                        <FaRegEdit />
                      </button> */}
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDelete(data.id)}
                        title="Delete"
                        style={{
                          padding: "4px 8px",
                          fontSize: "12px"
                        }}
                      >
                        <FaTrash />
                      </button>
                      {/* <button
                        className="btn btn-sm btn-warning"
                        onClick={() => {
                          const rowToAdd = rows.find((row) => row.id === data.id);
                          setSelectedRow(rowToAdd);
                          setOpenAddPlan(true);
                          setCropPlanMasterId(rowToAdd.id);
                          setFarmerName(rowToAdd.farmer);
                          setSelectedFarmerId(data.farmerId);
                        }}
                        title="Add Plan"
                        style={{
                          padding: "4px 8px",
                          fontSize: "12px"
                        }}
                      >
                        <FaPlus />
                      </button> */}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className='d-flex justify-content-between pb-0'>
          <div className='p-2'>
            Showing {(page - 1) * 10 + 1} to {Math.min(page * 10, totalItems)} of {totalItems} items
          </div>
          <div className='p-2'>
            <Pagination className="mb-0">
              <Pagination.First onClick={() => handlePageChange(1)} disabled={page === 1} />
              <Pagination.Prev onClick={() => handlePageChange(page - 1)} disabled={page === 1} />
              {renderPaginationItems()}
              <Pagination.Next onClick={() => handlePageChange(page + 1)} disabled={page === totalpage} />
              <Pagination.Last onClick={() => handlePageChange(totalpage)} disabled={page === totalpage} />
            </Pagination>
          </div>
        </div>

        {/* Delete Dialog */}
        <Dialog open={openDelete} onClose={() => setOpenDelete(false)}>
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <Typography>Are you sure you want to delete this crop plan?</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDelete(false)} color="primary">Cancel</Button>
            <Button onClick={handleDeleteRow} color="primary">Delete</Button>
          </DialogActions>
        </Dialog>
      </div>
    </Box>
  );
};

export default Cropplan;